import React from 'react';
import useStyles from '../../style/js-style/components/EAHint';
import {Typography} from "@mui/material";
import EAIcon from "./EAIcon";

const EAHint = ({title, content}) => {
  const {classes} = useStyles();
  return <div className={classes.root }>
    <div className={classes.icon}>
      <EAIcon icon={'lightbubble'}/>
    </div>
    <div className={classes.contentContainer}>
      {title&&<Typography variant={'h3'} className={classes.title}>{title}</Typography>}
      {content&& <div className={classes.content}>
        {content}
      </div>}
    </div>
  </div>
}

export default EAHint;